import React from "react"
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const TopGraphic = () => (
  <StaticQuery
    query={graphql`
      query {
        placeholderImage: file(relativePath: { eq: "graphics/feature_top_graphic.png" }) {
          childImageSharp {
            fluid(maxWidth: 3000) {
              ...GatsbyImageSharpFluid_noBase64
            }
          }
        }
      }
    `}
    render={data => <Img fluid={data.placeholderImage.childImageSharp.fluid} alt="Manage multi-asset investments in Stocks, Mutual Funds, Bonds, F&O & other asset classes on desktop, web & mobile"/>}
  />
)
export default TopGraphic
